/** Supabase allows the apex auth redirects, while www has separate storage. */
export function getCanonicalAuthUrl(url: URL): string | null {
  if (url.hostname !== "www.audiotrack.app") return null;
  if (url.pathname !== "/auth" && !url.pathname.startsWith("/auth/") && url.pathname !== "/reset-password") return null;
  const canonical = new URL(url);
  canonical.protocol = "https:";
  canonical.hostname = "audiotrack.app";
  canonical.port = "";
  return canonical.href;
}
